import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(value, fields, filters = [], hiddenFilter = '', page = 1, sortBy = 'nom_soc', sortDesc = false) {

    return Api().post('/client/debtors/search', qs.stringify({
      'search': value,
      'fields': fields,
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc
    }));
  },
  get(id) {
    return Api().get('/client/debtor/' + id);
  },
  post(debtorObject) {
    return Api().post('/client/debtor', qs.stringify({
      object: JSON.stringify(debtorObject)
    }));
  },
  delete_debtor(id) {
    return Api().delete('/debtor/' + id);
  },
  last_updated() {
    return Api().get('/client/debtors/last-updated');
  }
}